import {FC, useEffect, useState} from 'react'
import {Button} from '../../../components/Button/Button'
import {useNavigate, useParams} from 'react-router-dom'
import {PageTitle} from '../../../../_metronic/layout/core'
import {ModalWrapper} from '../../../components/Modals/General/ModalWrapper/ModalWrapper'
import {Datatable} from '../../../components/Datatable/Datatable'
import {Loading} from '../../../components/Loading/Loading'

import {GET, POST, PUT} from '../../../services/api'
import {
  dateBRtoDateUS,
  formatPhone,
  numberToCnpj,
  numberToCpf,
  toMoney,
} from '../../../utils/formater'
import useModals from '../../../hooks/useModals'
import moment from 'moment'
import {i18n} from '../../../translate/i18n'
import {Input} from '../../../components/Input/Input'
import {BreadCrumbs} from '../../../components/BreadCrumbs/breadCrumbrs'
import Swal from 'sweetalert2'
import usePluginSpace from '../../../hooks/usePluginSpace'

type HotelReservationType = {
  id: number
  roomId: number | null
  checkIn: string | null
  checkOut: string | null
  status: string
}

const DetalhesClienteContent: FC = () => {
  const dataAtual = new Date()
  const dataAtualArray = dataAtual.toLocaleDateString().split('T')[0].split('/')
  const [startDate, setStartDate] = useState(
    dateBRtoDateUS(`01/${dataAtualArray[1]}/${dataAtualArray[2]}`)
  )
  const [finalDate, setFinalDate] = useState(
    dateBRtoDateUS(`${dataAtualArray[0]}/${dataAtualArray[1]}/${dataAtualArray[2]}`)
  )
  const {showWrapperModal, closeWrapperModal} = useModals()
  const {id} = useParams()
  const [loading, setLoading] = useState(false)
  const [loadingCustomer, setLoadingCustomer] = useState(false)
  const [name, setName] = useState<string>('')
  const [email, setEmail] = useState<string>('')

  const [sendEmailBoasVindas, setSendEmailBoasVindas] = useState<{
    email: string
    sendIfExists: boolean
  }>({email: '', sendIfExists: false})

  const [phone, setPhone] = useState<string>('')
  const [document, setDocument] = useState<string>('')
  const [gender, setGender] = useState<string>('')
  const [status, setStatus] = useState<string>('')

  const [, setState] = useState<string>('')
  const [address, setAddress] = useState<string>('')
  const [customerGroup, setCustomerGroup] = useState<string>('Sem Grupo')
  const [city, setCity] = useState<string>('')
  const [total, setTotal] = useState<string>('0.00')
  const [totalitems, setTotalItems] = useState<string>('0')
  const [totalorders, setTotalOrders] = useState<string>('0')

  const [orders, setOrders] = useState<any[]>([])
  const [selectStatus] = useState<any>([
    {value: 'active', select: 'Ativo'},
    {value: 'inactive', select: 'Inativo'},
    {value: 'blocked', select: 'Bloqueado'},
    {value: 'pending', select: 'Pendente'},
  ])
  /** Usado para mudar status do Cliente, somente para Atacado */
  const {getPluginSpace, getIntegrations} = usePluginSpace()
  const [isWholeSaler, setIsWholeSaler] = useState(false)
  const [canSendEmail, setCanSendEmail] = useState(false)
  const [isHospitality, setIsHospitality] = useState(false)
  const [hotelReservations, setHotelReservations] = useState<HotelReservationType[]>([])
  const [loadingReservation, setLoadingReservation] = useState(false)

  const navigate = useNavigate()

  const getCustomer = async () => {
    try {
      const customerId = atob(id || '') // Convert id from string to number;

      if (!customerId) {
        return
      }
      const response = await POST(`/customer/filter/`, {id: customerId})

      if (!response || !response.success) {
        Swal.fire({
          icon: 'warning',
          title: 'Atenção',
          text: response.message || 'Cliente não encontrado!',
        })
        return
      }
      const res = response.data[0]

      const address = res.customerAddresses[res.customerAddresses.length - 1] || {
        zipCode: '',
        street: '',
        number: '',
        extra: '',
        district: '',
        city: '',
        state: '',
        reference: '',
        typeAddress: 'main',
      }
      setName(res.name)

      if (res.groupMemberShip && res.groupMemberShip.customerGroup) {
        setCustomerGroup(res.groupMemberShip.customerGroup.name)
      }

      const phone = res.customerPhones[res.customerPhones.length - 1]
        ? res.customerPhones[res.customerPhones.length - 1].numberPhone
        : ''

      setDocument(res.doc)
      setPhone(phone)
      setStatus(res.status)
      setGender(res.gender)

      setEmail(res.email)
      setSendEmailBoasVindas({email: res.email, sendIfExists: false})
      setState(address.city)
      setAddress(address.street.concat(' - ', address.district))
      setCity(address.city.concat(' - ', address.state))
      setLoadingCustomer(true)
      await getCustomerOrdersInfo(res.id)
      setLoadingCustomer(false)
    } catch (e) {
      console.log(e)
    }
  }

  const getCustomerOrdersInfo = async (id: number) => {
    try {
      const res = (await GET(`/orders/infoCustomer/${id}`)).data

      setTotal(res ? (res.total / 100).toString() : '0')
      setTotalItems(res ? res.items : 0)
      setTotalOrders(res ? res.orders : 0)
    } catch (e) {
      console.log(e)
    }
  }

  const getOrders = async () => {
    try {
      const res = await POST(`/orders/getOrderCustomer?order=ASC`, {
        customerId: parseInt(atob(id || '')),
        startDate: startDate + 'T00:00:00',
        finalDate: finalDate + 'T23:59:59',
      })
      const orders = res.data.map((row: any) => {
        const quantity = row.smartOrder.reduce((acc: number, item: any) => acc + item.quantity, 0)

        const codigoPedido =
          row.content && row.content.externalCodeERP ? `${row.content.externalCodeERP}` : row.id

        return {
          id: row.id,
          codigoPedido: codigoPedido,
          items: quantity,
          date: moment(row.created).format('DD/MM/YYYY hh:mm'),
          local: row.location.name,
          status: row.status[0].name,
          smartorder: row.smartOrder,
          orderIdExt: row.orderidExt,
        }
      })
      setOrders(orders)
    } catch (e) {
      console.log(e)
    }
  }

  // const loadSmartOrder = async (orderId: string) => {
  //   const listOrder = orders
  //   const list = listOrder.find((row) => row.id === parseInt(orderId))
  //   const listsmart = list.smartorder.map((row: any) => {
  //     return {
  //       product: row.content.productName,
  //       quantity: row.quantity,
  //       price: row.price,
  //       total: row.quantity * row.price,
  //     }
  //   })
  //   setSmartOrder(listsmart)
  // }

  async function getReservation() {
    try {
      setLoadingReservation(true)
      const customerId = atob(id || '') // Convert id from string to number;

      if (!customerId) {
        setLoadingReservation(false)
        return
      }

      const res = await GET(`/hotel-reservation/customer/${customerId}`)
      const reservationList = Array.isArray(res?.dados)
        ? res.dados
        : Array.isArray(res?.data)
        ? res.data
        : []

      if (res && res.success && reservationList.length > 0) {
        const formattedReservations = reservationList
          .filter((reservation: any) => reservation && reservation.id)
          .map((reservation: any) => ({
            id: reservation.id,
            roomId: reservation.roomId || null,
            checkIn: reservation.checkIn || null,
            checkOut: reservation.checkOut || null,
            status: reservation.status || 'pending',
          }))

        setHotelReservations(formattedReservations)
      } else {
        setHotelReservations([])
      }
    } catch (error) {
      setHotelReservations([])
      console.log(error)
    } finally {
      setLoadingReservation(false)
    }
  }

  async function loadTypePluginSpace() {
    try {
      const thisPluginsSpace = await getPluginSpace()

      if (thisPluginsSpace && thisPluginsSpace.wholeSaler) {
        setIsWholeSaler(true)
        return
      }

      if (thisPluginsSpace && thisPluginsSpace.type && thisPluginsSpace.type === 'hospitality') {
        setIsHospitality(true)
        await getReservation()
        return
      }
    } catch (error) {
      console.log(error)
    }
  }

  const init = async () => {
    setLoading(true)
    await Promise.all([getCustomer(), getPluginEmail(), loadTypePluginSpace(), getOrders()])
    setLoading(false)
  }

  useEffect(() => {
    init()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  async function updateCustomer() {
    try {
      setLoading(true)

      const response = await PUT(`/customer/${atob(id || '')}`, {
        status: status,
        alteredStatus: true,
      })

      setLoading(false)
      if (!response || !response.success) {
        let msg = 'Um erro ocorreu ao tentar atualizar o cliente'
        if (response.data && response.data.message) {
          msg = response.data.message
        }
        Swal.fire({
          title: 'Atenção',
          text: msg,
          icon: 'warning',
        })
        return
      }

      Swal.fire({
        title: 'Sucesso',
        text: 'Cliente atualizado com sucesso',
        icon: 'success',
      }).then(() => {
        if (status === 'active' && canSendEmail) {
          showWrapperModal('Enviar Email')
        }
      })
    } catch (error: any) {
      let msg = 'Um erro ocorreu ao tentar atualizar o cliente'

      if (error.data && error.data.message) {
        msg = error.data.message
      }

      Swal.fire({
        title: 'Atenção',
        text: msg,
        icon: 'warning',
      })
    }
  }

  function showGender(gender: string) {
    switch (gender) {
      case 'masculino':
        return <i className='bi bi-gender-male fs-4 me-2'></i>
      case 'feminino':
        return <i className='bi bi-gender-female fs-4 me-2'></i>
      default:
        return <i className='bi bi-gender-neuter fs-4 me-2'></i>
    }
  }

  async function getPluginEmail() {
    try {
      const thisPluginsSpace = await getIntegrations()

      const emailPlugin = thisPluginsSpace.find((plugin) => plugin.plugintemplateId === 235)
      if (emailPlugin && emailPlugin.content && emailPlugin.content.able === `1`) {
        setCanSendEmail(true)
      }
    } catch (error) {
      console.log(error)
    }
  }

  async function sendEmail() {
    try {
      if (
        !sendEmailBoasVindas.email ||
        !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(sendEmailBoasVindas.email)
      ) {
        Swal.fire({
          icon: 'error',
          title: 'Erro',
          text: 'Por favor, insira um e-mail válido!',
          customClass: {
            popup: 'swal2-custom-zindex',
          },
        })
        return
      }

      const payload = {
        email: sendEmailBoasVindas.email,
        name: name,
        sendIfExists: sendEmailBoasVindas.sendIfExists,
      }

      setLoading(true)
      const response = await POST(`/email/send_email_boas_vindas`, payload)
      setLoading(false)
      if (!response || !response.success) {
        Swal.fire({
          title: 'Atenção',
          text: 'Um erro ocorreu ao tentar enviar o email',
          icon: 'warning',
        })

        return
      }
      Swal.fire({
        title: 'Sucesso',
        text: 'Email enviado com successo',
        icon: 'success',
      })
      closeWrapperModal()
    } catch (error) {
      let msg = 'Um erro ocorreu ao tentar enviar email ao cliente'

      if (
        typeof error === 'object' &&
        error !== null &&
        'data' in error &&
        typeof (error as any).data === 'object' &&
        (error as any).data !== null &&
        'message' in (error as any).data
      ) {
        msg = (error as any).data.message
      }

      if (typeof error === 'string') {
        msg = error
      }

      setLoading(false)
      Swal.fire({
        title: 'Atenção',
        text: msg,
        icon: 'warning',
      })
    }
  }

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div className='row g-5 gx-xxl-12'>
          <div className='card p-5'>
            <div className='card-header'>
              <div className='card-toolbar d-flex justify-content-between w-100 '>
                <h2 className='text-black-700'>Visão Geral</h2>
                {isWholeSaler && (
                  <Button
                    text={i18n.t(`general.edit`)}
                    color='primary'
                    iconColor='#FFF'
                    size='small'
                    horizontalPadding={6}
                    btnAttr={{
                      type: 'button',
                    }}
                    click={() => navigate('/customer/report/edit/' + id)}
                    btnClass='fw-bolder'
                  />
                )}
              </div>
            </div>

            <div className='d-flex justify-content-between p-10 border-bottom'>
              <div className='d-flex align-items-center '>
                <div className='d-flex align-items-center justify-content-center rounded-circle bg-primary w-100px h-100px text-white'>
                  <p className='display-5 m-0'>{name[0]}</p>
                </div>

                <div className='ms-10 text-muted fw-bold d-flex flex-column gap-2'>
                  <h2 className='text-gray-700'>{name}</h2>
                  <div className=''>
                    <span className='text-hover-primary me-12'>
                      {email && (
                        <>
                          <i className='bi bi-envelope fs-4 me-2'></i>
                          {email}
                        </>
                      )}

                      <span className='ms-2'>
                        <svg
                          xmlns='http://www.w3.org/2000/svg'
                          width='16'
                          height='16'
                          fill='currentColor'
                          className='bi bi-person-vcard fs-4 me-2'
                          viewBox='0 0 16 16'
                        >
                          <path d='M5 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4m4-2.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5M9 8a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4A.5.5 0 0 1 9 8m1 2.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5' />
                          <path d='M2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zM1 4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H8.96q.04-.245.04-.5C9 10.567 7.21 9 5 9c-2.086 0-3.8 1.398-3.984 3.181A1 1 0 0 1 1 12z' />
                        </svg>
                        {document.length > 11 ? (
                          <>CNPJ: {numberToCnpj(document)}</>
                        ) : (
                          <>CPF: {numberToCpf(document)}</>
                        )}
                      </span>
                    </span>
                  </div>

                  <div className='d-flex flex-column gap-2'>
                    {phone && (
                      <span className='text-hover-primary'>
                        <i className='bi bi-telephone fs-4 me-2'></i>
                        {formatPhone(phone)}
                      </span>
                    )}

                    {isWholeSaler && (
                      <>
                        <span className='text-hover-primary'>
                          <i className='bi bi-people fs-4 me-2'></i>
                          {customerGroup}
                        </span>
                      </>
                    )}

                    {!(document.length > 11) && gender && (
                      <span className='text-hover-primary'>
                        {showGender(gender)}
                        {gender}
                      </span>
                    )}
                  </div>

                  {address.replace(' - ', '').trim() && (
                    <div className='d-flex flex-column'>
                      <span className='text-hover-primary'>
                        <i className='bi bi-pin-map fs-4 me-2'></i>
                        {address}
                        <br />
                        {city}
                      </span>
                    </div>
                  )}
                </div>
              </div>

              {isWholeSaler && (
                <div className='d-flex flex-column  justify-content-between w-25'>
                  <Input
                    inputAttr={{
                      type: 'select',
                    }}
                    label='Status do Cliente'
                    options={selectStatus}
                    change={(value: string) => {
                      setStatus(value)
                    }}
                    value={status}
                  />

                  <Button
                    text={i18n.t(`buttons.save`)}
                    color='primary'
                    iconColor='#FFF'
                    size='small'
                    horizontalPadding={6}
                    btnAttr={{
                      type: 'button',
                    }}
                    click={updateCustomer}
                    btnClass='fw-bolder'
                  />
                </div>
              )}
            </div>
            {loadingCustomer ? (
              <Loading />
            ) : (
              <div className='d-flex align-items-center justify-content-between p-10'>
                <div className='d-flex align-items-center'>
                  <i className='bi bi-coin display-6 text-muted me-5'></i>
                  <div>
                    <p className='mb-2 fw-bold'>{i18n.t(`customer_list.total_profit`)}</p>
                    <p className='mb-2 fw-bolder fs-4'>{toMoney(total)}</p>
                  </div>
                </div>
                <div className='d-flex align-items-center'>
                  <i className='bi bi-stars display-6 text-muted me-5'></i>
                  <div>
                    <p className='mb-2 fw-bold'>{i18n.t(`customer_list.total_itens`)}</p>
                    <p className='mb-2 fw-bolder fs-4 text-center'>{totalitems}</p>
                  </div>
                </div>
                <div className='d-flex align-items-center'>
                  <i className='bi bi-pie-chart display-6 text-muted me-5'></i>
                  <div>
                    <p className='mb-2 fw-bold'>{i18n.t(`customer_list.total_orders`)}</p>
                    <p className='mb-2 fw-bolder fs-4 text-center'>{totalorders}</p>
                  </div>
                </div>
              </div>
            )}
          </div>

          {isHospitality && (loadingReservation || hotelReservations.length > 0) && (
            <div className='card pb-5'>
              <div className='card-header py-5'>
                <div>
                  <h4 className='text-gray-800 mb-1'>Reservas do Hotel</h4>
                </div>
              </div>

              <div className='card-body pt-2 pb-0'>
                {loadingReservation ? (
                  <div className='d-flex align-items-center justify-content-center py-10'>
                    <div className='spinner-border text-primary' role='status'>
                      <span className='visually-hidden'>Carregando...</span>
                    </div>
                  </div>
                ) : (
                  <Datatable
                    data={hotelReservations.map((reservation) => ({
                      id: reservation.id,
                      reservationId: `#${reservation.id}`,
                      room: reservation.roomId || '-',
                      checkIn: reservation.checkIn
                        ? moment(reservation.checkIn).format('DD/MM/YYYY HH:mm')
                        : '-',
                      checkOut: reservation.checkOut
                        ? moment(reservation.checkOut).format('DD/MM/YYYY HH:mm')
                        : '-',
                      status: reservation.status || '-',
                    }))}
                    headers={[
                      {key: 'Reserva', value: 'reservationId', type: 'default'},
                      {key: 'Quarto', value: 'room', type: 'default'},
                      {key: 'Check-in', value: 'checkIn', type: 'default'},
                      {key: 'Check-out', value: 'checkOut', type: 'default'},
                      {key: 'Status', value: 'status', type: 'default'},
                      {key: i18n.t(`general.actions`), value: 'acoes', type: '', noOrder: true},
                    ]}
                    options={[
                      {
                        icon: '',
                        isButton: true,
                        textButton: 'Visualizar',
                        action: (item) => {
                          window.open(`/hospitality/hotel-reservation/editar/${item.id}`, '_blank')
                        },
                        color: 'primary',
                      },
                    ]}
                    color='primary'
                    showControls={false}
                    maxHeight='450px'
                    headerFixed
                  />
                )}
              </div>
            </div>
          )}

          <div className='card pb-5 mt-10'>
            <div className='card-header py-5'>
              <h4 className='text-gray-800'>{i18n.t(`customer_list.select_time`)}</h4>
              <BreadCrumbs />
              <div className='d-flex align-items-end mt-5 flex-row w-100 gap-5'>
                <div className='flex-1'>
                  <Input
                    inputAttr={{type: 'date'}}
                    label={i18n.t(`customer_list.first`)}
                    defaultValue={startDate}
                    value={startDate}
                    change={setStartDate}
                    maxLength={finalDate}
                  />
                </div>
                <div className='flex-1'>
                  <Input
                    inputAttr={{type: 'date'}}
                    label={i18n.t(`customer_list.end`)}
                    value={finalDate}
                    change={setFinalDate}
                    minLength={startDate}
                  />
                </div>
                <div className='flex-1'>
                  <Button
                    color='primary'
                    text={i18n.t(`buttons.search`)}
                    click={() => getOrders()}
                    btnClass='float-right'
                  />
                </div>
              </div>
            </div>
            <div className='px-10 py-5'>
              <Datatable
                data={orders}
                headers={[
                  {key: 'Id', value: 'codigoPedido', type: 'default'},
                  {key: 'Itens', value: 'items', type: 'default'},
                  {key: 'Data', value: 'date', type: 'default'},
                  {key: 'Local', value: 'local', type: 'default'},
                  {
                    key: 'Status',
                    value: 'status',
                    type: 'default',
                  },
                  {key: i18n.t(`general.actions`), value: 'acoes', type: '', noOrder: true},
                ]}
                options={[
                  {
                    icon: '',
                    isButton: true,
                    textButton: i18n.t(`buttons.view`),
                    action: (item) => {
                      window.open(`/order/saleorder/${item.id}`, '_blank')
                      // setOrderId(item.id)
                      // loadSmartOrder(item.id)
                      // showWrapperModal(`${i18n.t(`customer_list.order_detail`)} #${item.id}`)
                    },
                    color: 'primary',
                  },
                ]}
                color='primary'
              />
            </div>
            <div className='px-10'>
              <Button
                text={i18n.t(`buttons.back`)}
                color='info'
                size='small'
                horizontalPadding={5}
                btnAttr={{
                  type: 'button',
                }}
                click={() => navigate('/customer/report')}
                btnClass='fw-bolder me-3'
              />
            </div>
          </div>

          <ModalWrapper
            confirmAction={() => {}}
            noCloseOverlay={false}
            noCloseButton
            noAction
            zIndex={1000}
          >
            <div className='w-100 d-flex flex-column'>
              <div className='w-100 d-flex flex-column mt-2 gap-2'>
                <div className='d-flex flex-column gap-2'>
                  <p className='text-dark fs-6 mt-6'>
                    Deseja enviar o e-mail de boas-vindas para o cliente?
                  </p>
                  <Input
                    value={sendEmailBoasVindas.email}
                    grow
                    placeholder='Digite o e-mail do cliente'
                    change={(value: string) =>
                      setSendEmailBoasVindas({...sendEmailBoasVindas, email: value})
                    }
                    inputAttr={{
                      type: 'email',
                    }}
                  />

                  <Input
                    value={sendEmailBoasVindas.sendIfExists}
                    grow
                    label='Enviar e-mail mesmo que já tenha sido enviado anteriormente?'
                    checked={sendEmailBoasVindas.sendIfExists}
                    change={(value: boolean) =>
                      setSendEmailBoasVindas({...sendEmailBoasVindas, sendIfExists: value})
                    }
                    inputAttr={{
                      type: 'checkbox',
                    }}
                  />
                </div>
              </div>
              <div className='w-100 d-flex flex-row justify-content-end'>
                <button
                  onClick={sendEmailBoasVindas.email ? sendEmail : closeWrapperModal}
                  className='btn btn-small fw-bolder mt-4'
                  style={{
                    backgroundColor:
                      !sendEmailBoasVindas.email || !sendEmailBoasVindas.sendIfExists
                        ? '#6E7586'
                        : '#6993ff',
                    color: '#FFF',
                  }}
                  disabled={!sendEmailBoasVindas.email || !sendEmailBoasVindas.sendIfExists}
                >
                  <p style={{fontSize: 14, marginBottom: 0}}>
                    {sendEmailBoasVindas.email ? 'Enviar' : i18n.t(`buttons.close`)}
                  </p>
                </button>
              </div>
            </div>
          </ModalWrapper>
        </div>
      )}
    </>
  )
}

const DetalhesCliente: FC = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {title: 'Dashboard', path: 'dashboard', isActive: true},
          {title: i18n.t(`customer_list.customer_list`), path: 'customer/report', isActive: true},
          {title: i18n.t(`customer_list.detail`), path: 'customer/report', isActive: true},
        ]}
      >
        {i18n.t(`customer_list.detail`)}
      </PageTitle>
      <DetalhesClienteContent />
    </>
  )
}

export {DetalhesCliente}
